import { pubsub, liveBinding } from "@utils/";

const ExternalLinkHandler = () => {
    // bindings for all anchor elements
    liveBinding("click", "a", (el, event) => {
        const href = el.getAttribute("href");
        const comp = new RegExp(document.location.host);
        const live = new RegExp("www.vaxiplace.com.au");

        if (
            href &&
            !comp.test(href) &&
            !live.test(href) &&
            (href.indexOf("http://") > -1 || href.indexOf("https://") > -1)
        ) {
            // is external href, store href, prompt confirm lightbox/modal
            event.preventDefault();
            window.curentExternalLink = href;
            pubsub.publish(`open-external-link`);
        }
    });

    // bindings for external link confirmation
    liveBinding("click", "[data-external-link-confirmation]", (el, event) => {
        if (window.curentExternalLink) {
            //document.location.href = window.curentExternalLink;
            window.open(window.curentExternalLink, "_blank").focus();
            pubsub.publish("close-external-link");
        } else {
            pubsub.publish("close-external-link");
        }
    });

    // on external link modal close
    pubsub.subscribe(`close-external-link`, () => {
        window.curentExternalLink = null;
    });
};

export default ExternalLinkHandler;
